export default __webpack_public_path__ + "static/media/keyfessor-white-logo.86e5b12c.png";